import { reducer } from 'react-redux-toastr';
import { ADD_TOASTR } from 'react-redux-toastr/src/constants';

export default (state, action, personalConfiguration) => {
  if (action.type === ADD_TOASTR && action.payload.type === 'success' && personalConfiguration.hideNotifications) {
    return reducer(state, { type: '' });
  }
  return reducer(state, action);
};